import {WarningMessageAction} from '#/atoms/warning-message-action';
import {
  ActionMenuHeader,
  ActionMenuHeaderButton,
  ActionMenuHeaderIcons,
} from '#/components/actionmenu/action-menu-header';
import {WalletContext} from '#/contexts/wallet-provider';
import {useInvalidateQueries} from '#/hooks/query/base/use-invalidate-queries';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Land} from 'shareland-common';

export const ActionMenuLandInformationNotFound: FunctionComponent<{land: Land}> = ({land}) => {
  const {accountResult} = useContext(WalletContext);
  const {t} = useTranslation('translation');
  const invalidateQueries = useInvalidateQueries();

  const {
    actionMenu: {close},
  } = useQueryNavigationActions();

  return (
    <>
      <ActionMenuHeader land={land} landMarketInfo={undefined}>
        <ActionMenuHeaderButton onClick={close}>
          <ActionMenuHeaderIcons.Close />
        </ActionMenuHeaderButton>
      </ActionMenuHeader>

      <WarningMessageAction
        className='grow h-full'
        message={t('components.warningMessageAction.couldntRetrieveLocationData.message')}
        buttonContent={t('components.warningMessageAction.couldntRetrieveLocationData.cta')}
        action={() => {
          invalidateQueries.useLandMarketInfos(land.id);
          invalidateQueries.useLandAccountInfos(accountResult.address, land.id);
        }}
      />
    </>
  );
};
